module.exports = __webpack_public_path__ + "static/media/europeanunion.bf1c35eb.svg";